import { useState } from "react";
import { FaLock, FaLockOpen } from "react-icons/fa";
import { Field, ErrorMessage, useField } from "formik";

const InputField = ({ name = "", value = "", label = "", options = [], type = "", onChange, ...rest }) => {
	const [showPassword, setShowPassword] = useState(false);
	const [ , meta] = useField(name);

	const togglePasswordVisibility = () => { setShowPassword((prev) => !prev); };

	const errorClass = meta.touched && meta.error ? "animate-shake border-red-500" : "";
	const base = "bg-white border placeholder:text-gray-500 bg-transparent text-black border-blue-700 w-full p-2 pr-8 rounded-md focus:border-rs-rojo focus:outline-none ring-0 disabled:cursor-not-allowed disabled:bg-black disabled:text-white";

	return (
		<div className="w-full relative">
			<label htmlFor={name} className="text-rs-azul absolute left-0 font-bold"> {label} </label>
			<br />
			{type === "password" ? (
				<div className="relative">
					<Field className={`${base} ${errorClass}`} name={name} placeholder={value} type={showPassword ? "text" : "password"} {...rest}/>
					<button type="button" onClick={togglePasswordVisibility} className="absolute top-0 right-0 h-full flex items-center p-2 text-gray-500">
						{showPassword ? (
							<FaLockOpen className="text-green-400"/>
						) : (
							<FaLock className="text-red-500"/>
						)}
					</button>
				</div>
			) : type === "textarea" ? (
				<div className="relative">
					<Field className={`${base} ${errorClass} resize-y`} as="textarea" rows={4} name={name} placeholder={value} maxLength={10000} {...rest}/>
				</div>
			)  :  type === "file" ? (
				<div className="relative">
					<input
						className={`${base} ${errorClass}`}
						name={name} type="file" id={name} onChange={(e) => { if (onChange) { onChange(e, rest.setFieldValue); } }}  {...rest}
					/>
				</div>
			) : type !== "select" && type !== "checkbox" && type !== "color" ? (
				<div className="relative">
					<Field className={`${base} ${errorClass}`} name={name} placeholder={value} type={type} maxLength={type === "text" ? 150 : undefined} {...rest}/>
				</div>
			) : type === "checkbox" ? (
				<div className="flex items-center ">
					<Field
						className={`form-checkbox h-11 w-11 border border-blue-700 focus:border-rs-rojo focus:outline-none ring-0 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-400 ${ errorClass ? "animate-shake border-red-500" : "" }`}
						name={name} type="checkbox" {...rest}
					/>
				</div>
			) : (
				<Field className={`${base} ${errorClass}`} name={name} as="select" {...rest}>
					<option value="" disabled>
						Selecciona una opción
					</option>
					{options.map((option) => (
						<option key={option.value} value={option.value} className="text-black">
							{option.label}
						</option>
					))}
				</Field>
			)}
			<ErrorMessage name={name}>
				{(message) => ( <div className="absolute right-0 text-sm text-red-500 animate-shake">{message}</div> )}
			</ErrorMessage>
		</div>
	);
};

export default InputField;
